var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('article',{staticClass:"left-article"},[_c('article-content',{ref:"myArticle"})],1),_c('main',{staticClass:"right-main"},[_c('router-view',{on:{"emitListen":_vm.ww}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }